import { render, staticRenderFns } from "./preProblemDetail.vue?vue&type=template&id=feeb0cc0"
import script from "./preProblemDetail.vue?vue&type=script&lang=js"
export * from "./preProblemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports